<template>
  <div class="w-full h-full pt-5">
    <div class="flex">
      <h1 class="text-xl text-left font-extrabold pl-4">Organisation Design</h1>
      <div class="w-7/12 mt-1 ml-4">
        <Breadcrumb :items="breadcrumbs" />
      </div>
    </div>
    <loader v-if="isLoading" size="xxs" :loader-image="false" />
    <div class="mt-6 mx-3" v-else>
      <div class="mx-3">
        <Tabs
          class="mt-6 mx-4"
          :tabs="tabs"
          :active-tab="activeTab"
          @currentTab="handleActiveTab($event)"
          :border="true"
        />
      </div>
      <JobLevel v-if="activeTab === 'Job Level' || activeTab === 'Grade Level'" 
        :is-job-level="jobLevelProgression[0] === 'jobLevel'"
      />
      <JobGrade v-if="activeTab === 'Job Grade' || activeTab === 'Steps'" 
        :is-job-level="jobLevelProgression[0] === 'jobLevel'"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Tabs from "@scelloo/cloudenly-ui/src/components/tab";
import JobLevel from "./JobLevel";
import JobGrade from "./JobGrade";

export default {
  name: "Designation",
  components: {
    Breadcrumb,
    JobLevel,
    JobGrade,
    Tabs,
  },
  data() {
    return {
      activeTab: "Job Level",
      jobLevelProgression: [],
      isLoading: true
    };
  },
  computed: {
    tabs() {
      if(this.jobLevelProgression[0] === 'jobLevel'){
        return  ["Job Level", "Job Grade"]
      }else {
        return  ["Grade Level", "Steps"]
      }
    },
    breadcrumbs(){
      return [
        {
          disabled: false,
          text: "Organisation Design",
          id: "",
        },
        {
          disabled: false,
          text: `${this.jobLevelProgression[0] === 'jobLevel' ? 'Job Level & Grades' : 'Grade Level & Steps'}`,
          id: ``,
        },
      ];
    },
  },
  methods:{
    handleActiveTab(currentActiveTab) {
      this.activeTab = currentActiveTab
    },
  },
  async created() {  
    const { data } = await this.$_getOrgProfile();
    this.jobLevelProgression = data.org.jobLevelProgression;
    const activeTab = this.jobLevelProgression[0] === "jobLevel" ? "Job Level" : "Grade Level";
    this.handleActiveTab(activeTab)
    this.isLoading = false
  },
};
</script>